import { SERVER_API_PATH, reportApiError, serverApi } from "api/api-server-actions";
import { SectionType } from "components/server-types";
import { slices, store } from "store/index";

export async function serverCreateLinkedSections(
  sectionId: string,
  count: number,
  title: string,
): Promise<void> {
  try {
    const response = await serverApi.post(`${SERVER_API_PATH}/publishing/linked_sections/`, {
      section_id: sectionId,
      count,
      title,
    });
    const sections = response.data as SectionType[];
    store.dispatch(slices.sections.actions.updateMany(sections));
  } catch (error) {
    reportApiError("serverCreateLinkedSections", error);
    throw error;
  }
}
